export default "__VITE_ASSET__DMTyeQWW__"